import { render, staticRenderFns } from "./b_Capacity.vue?vue&type=template&id=51a4ff78&scoped=true&"
import script from "./b_Capacity.vue?vue&type=script&lang=js&"
export * from "./b_Capacity.vue?vue&type=script&lang=js&"
import style0 from "./b_Capacity.vue?vue&type=style&index=0&id=51a4ff78&prod&lang=css&"
import style1 from "./b_Capacity.vue?vue&type=style&index=1&id=51a4ff78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a4ff78",
  null
  
)

export default component.exports